import React, { useState, useEffect, useRef } from "react";
import useAxios from "hooks/useAxios";
import ReactStrapTable from "components/reactStrapTable";
import { dateFormate, cellRendererCheck, fileFormatter } from "utils/columns";
import DeleteIcon from "assets/icon/icon-icon-options-delete.svg";
import DeleteHoverIcon from "assets/icon/icon-icon-options-delete-hover.svg";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import { Button } from "reactstrap";
import { Formik, Field } from "formik";
import HoverImage from "react-hover-image/build";
import Confirm from "components/Confirm";
import { toast } from "react-toastify";
import { ModuleAccess } from "utils/moduleaccess";

const RxComment = (props) => {
  const API = useAxios();
  const { tenantID, claimID, onCommentEdit, refetch } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const formikRef = useRef();
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [commentId, setCommentId] = useState(-1);

  const hasPermission = (code) => {
    return ModuleAccess("RXM", code);
  };
  const fetchClaimComments = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(
        `/${tenantID}/Comments/RxComment/${claimID}`,
        {
          hideLoader: true,
        }
      );
      setLoading(false);
      setData(data);
    } catch (error) {
      setLoading(false);
    }
  };

  const cellRenderEdit = (row) => {
    return (
      <div className="d-flex align-items-center">
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => onEdit(row)}
          title="Edit"
        >
          <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
        </Button>
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handleDeleteConfirmation(row)}
          title="Delete"
        >
          <HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt="" />
        </Button>
      </div>
    );
  };

  const onEdit = (row) => {
    onCommentEdit(row);
  };

  const deleteRow = async () => {
    handleDeleteConfirmation();
    let result = await API.post(
      `/${tenantID}/Comments/inactivecomment/${claimID}/${commentId}`,
      null,
      {
        hideLoader: true,
      }
    );
    if (result) {
      toast.success("Item removed successfully");
      fetchClaimComments();
    }
  };

  const handleDeleteConfirmation = async (row) => {
    setDeleteConfirm(!isDeleteConfirm);
    if (row) setCommentId(row.commentID);
  };

  useEffect(() => {
    fetchClaimComments();
  }, [refetch]);

  const download = async (file) => {
    const { fileRepositoryID } = file;
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
      const res = await API.get(
        `/${tenantID}/Comments/Download/${parseInt(
          claimID
        )}/${fileRepositoryID}?access_token=${access_token}`,
        {
          responseType: "blob",
        }
      );
      if (res.request.responseType === "blob") {
        window.open(res.request.responseURL);
      }
    } catch (error) {}
  };

  const columns = [
    {
      dataField: "delete",
      text: "Options",
      width: 100,
      cellRenderer: (row) => cellRenderEdit(row),
      show: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "comments",
      text: "Comments",
      show: true,
      width: 200,
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      show: true,
      width: 110,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: "createdBy",
      text: "Created By",
      show: true,
      width: 100,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
    },
    {
      dataField: "fileName",
      text: "Attachments",
      show: true,
      width: 140,
      cellRenderer: (row) => fileFormatter(row, download),
    },
  ];

  return (
    <>
      <Formik innerRef={formikRef} enableReinitialize={true}>
        <ReactStrapTable
          id="commnets"
          height={30 * data.length}
          columns={columns}
          data={data}
          loading={loading}
        />
      </Formik>
      <Confirm
        isOpen={isDeleteConfirm}
        loading={loading}
        message="Are you sure you want to delete this comment?"
        onToggle={handleDeleteConfirmation}
        onCancel={handleDeleteConfirmation}
        onContinue={deleteRow}
      />
    </>
  );
};

export default RxComment;
